import React, { useEffect, useState } from "react";
import ArrowUpIconWebView from "@/components/webview/icon/ArrowUpIconWebView";
import { cn } from "@/libs/utils";
const SCROLL_THRESHOLD = 150;

const FloatingButtonWebView = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const scrollTarget = document.getElementById("webview-scroll-container");
    const onScroll = () => {
      const scrollYFromWindow = window.scrollY;
      const scrollYFromTarget = scrollTarget?.scrollTop ?? 0;

      const scrollMove = Math.max(scrollYFromWindow, scrollYFromTarget);

      setVisible(scrollMove > SCROLL_THRESHOLD);
    };

    window.addEventListener("scroll", onScroll);
    scrollTarget?.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      scrollTarget?.removeEventListener("scroll", onScroll);
    };
  }, []);

  const handleClick = () => {
    const scrollTarget = document.getElementById("webview-scroll-container");

    if (scrollTarget) {
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "fixed bottom-4 left-4 z-50 rounded-full bg-[#323232] p-3 text-white shadow-lg transition",
        visible
          ? "pointer-events-auto opacity-100"
          : "pointer-events-none opacity-0",
      )}
    >
      <ArrowUpIconWebView />
    </button>
  );
};

export default FloatingButtonWebView;
